import {
  LoginApi,
  LogoutApi,
  getAssignedPermissionsForCurrentUserApi,
  resetPasswordApi,
  updateProfileDetailsApi,
} from 'src/api/login';
import {
  LOGIN,
  LOGOUT,
  GET_ASSIGNED_PERMISSIONS_FOR_CURRENT_USER,
  RESET_PASSWORD,
  UPDATE_PROFILE_DETAILS,
} from 'src/redux/Actions/Type';

export const login = (isUserdata) => (dispatch) =>
  LoginApi(isUserdata).then((data) => {
    const {
      token,
      user_details: userdata,
      super_admin: superAdmin,
      organisation_admin: organisationAdmin,
      normal_user: normalUser,
      user_type: userType,
      user_role: userRole,
      first_stage_assigned: firstStageAssigned,
    } = data;
    dispatch({
      type: LOGIN,
      payload: {
        userdata,
        token,
        superAdmin,
        organisationAdmin,
        normalUser,
        userType,
        userRole,
        firstStageAssigned,
      },
    });
    return Promise.resolve(data);
  });

export const logout = () => (dispatch) => {
  LogoutApi().then(() => {
    dispatch({
      type: LOGOUT,
    });
  });
};

export const getAssignedPermissionsForCurrentUser =
  (tenantOrganisationId, appLabelId) => (dispatch) =>
    getAssignedPermissionsForCurrentUserApi(
      tenantOrganisationId,
      appLabelId,
    ).then((data) => {
      dispatch({
        type: GET_ASSIGNED_PERMISSIONS_FOR_CURRENT_USER,
        payload: data,
      });
      return Promise.resolve(data);
    });

export const resetPassword = (resetPasswordPayload) => (dispatch) =>
  resetPasswordApi(resetPasswordPayload).then((data) => {
    dispatch({
      type: RESET_PASSWORD,
      payload: data,
    });
    return Promise.resolve(data);
  });

export const updateProfileDetails = (payload) => (dispatch) =>
  updateProfileDetailsApi(payload).then((data) => {
    dispatch({
      type: UPDATE_PROFILE_DETAILS,
      payload: data,
    });
    return Promise.resolve(data);
  });
